import { render, staticRenderFns } from "./MarketGroupButtons.vue?vue&type=template&id=3d03a9f9&"
import script from "./MarketGroupButtons.vue?vue&type=script&lang=js&"
export * from "./MarketGroupButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports